import { UserAccount } from "src/types/User";

/**
 * True when the user has no organizationId or no cohortId set. The
 * server-side auto-assign engine leaves users in this state while assignment
 * is pending and when no Organization matches. Callers must inspect
 * organizationAssignmentStatus before deciding whether to load or waitlist.
 * Purely structural — no time, no environment.
 */
export default function isOrphan(account: UserAccount): boolean {
  return !account.organizationId || !account.cohortId;
}
